import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DateIncludedInAccountingWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.sale.validation.tax-liability-day.date-included-in-accounting');
    }
}
